import { pushUnsafe } from "@swan-io/chicane";
import { FullScreenScrollView } from "../components/FullScreenScrollView";
import { t } from "../utils/i18n";
import { router } from "../utils/routes";
import { IconPage } from "./IconPage";

type Props = {
  fallbackUrl?: string;
};

export const NotFoundPage: React.FC<Props> = ({ fallbackUrl }) => {
  return (
    <FullScreenScrollView
      paddingHorizontal={24}
      paddingVertical={24}
      maxWidth={478}
      verticalCenter={0.5}
    >
      <IconPage
        variant="primary"
        icon="help_circle"
        title={t("not_found_page.title")}
        description={t("not_found_page.message")}
        submitText={t("not_found_page.back_to_home")}
        onSubmit={() => {
          const url = fallbackUrl || router.Index();
          pushUnsafe(url);
        }}
      />
    </FullScreenScrollView>
  );
};
